var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, useState } from 'react';
import { useScrollingUp } from '../../../../util';
import { Button, Container, ItemsContainer, Link, SubNavHeader, SubnavItem, } from './SubNavDesktopStyles';
export var SubNavDesktop = forwardRef(function (_a, fRef) {
    var rightLink = _a.rightLink, _b = _a.depthOffset, depthOffset = _b === void 0 ? 0 : _b, items = _a.items, logo = _a.logo, id = _a.id;
    var _c = useState(null), selectedValue = _c[0], setSelectedValue = _c[1];
    var isScrollingUp = useScrollingUp(true);
    return (React.createElement(SubNavHeader, { id: id, ref: fRef, showHeader: isScrollingUp, depthOffset: depthOffset },
        React.createElement(Container, null,
            logo && (React.createElement(Link, __assign({}, logo.link),
                React.createElement("img", __assign({}, logo.image, { alt: logo.image.alt })))),
            items ? (React.createElement(ItemsContainer, null, items.map(function (_a, index) {
                var title = _a.title, onClick = _a.onClick;
                return (React.createElement(SubnavItem, { key: index },
                    React.createElement(Button, { isSelected: title === selectedValue, onClick: function (e) {
                            setSelectedValue(title);
                            onClick && onClick(e);
                        } }, title)));
            }))) : null,
            React.createElement(Link, __assign({}, rightLink), rightLink.label))));
});
